/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDlvryNavigationMenu containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum menuItemsSource {
    categories = 'categories',
    static = 'static'
}

export const enum productsMenuStyle {
    default = 'default',
    grid = 'grid'
}

export interface IDlvryNavigationMenuConfig extends Msdyn365.IModuleConfig {
    menuItemsSource?: menuItemsSource;
    cmsNavItems?: ICmsNavItemsData[];
    productsMenuStyle?: productsMenuStyle;
    productsMenuItemPosition?: number;
    showProductsMenuItemOnlyAuthorized?: boolean;
    showAllProductsLink?: Msdyn365.ILinkData;
    showAllProductsLabel?: string;
    className?: string;
    clientRender?: boolean;
}

export interface IDlvryNavigationMenuResources {
    productsMenuItemLabel: string;
    menuAriaLabel: string;
    navigationOverflowButtonLabel: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    openInNewTab?: boolean;
    showOnlyUnauthorized?: boolean;
    showOnlyAuthorized?: boolean;
    highlight?: boolean;
    companyChainMatches?: ICompanyChainMatchesData[];
    subMenus?: ISubMenusData[];
}

export const enum CompanyChainMatchesMatchType {
    exact = 'exact',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    contains = 'contains'
}

export interface ICompanyChainMatchesData {
    matchType: CompanyChainMatchesMatchType;
    matchValue: string;
}

export interface ISubMenusData {
    linkText: string;
    linkUrl: Msdyn365.ILinkData;
    showOnlyUnauthorized?: boolean;
    showOnlyAuthorized?: boolean;
}

export interface IDlvryNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: IDlvryNavigationMenuResources;
    config: IDlvryNavigationMenuConfig;
    slots: {
        cartIcon: React.ReactNode[];
    };
}
